import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import PageHero from "@/components/PageHero";
import CtaSection from "@/components/CtaSection";
import Reveal from "@/components/Reveal";
import Seo from "@/components/Seo";

export default function ServicePageLayout({
    overline,
    title,
    heroDescription,
    image,
    imageAlt,
    intro,
    coveredTitle,
    covered,
    closing,
    seoTitle,
    seoDescription,
    ctaLabel = "Book a Consultation",
    ctaLink = "/contact",
    gallery = null,
}) {
    return (
        <div>
            <Seo title={seoTitle} description={seoDescription} />
            <PageHero overline={overline} title={title} description={heroDescription} />

            <section className="bg-white py-20 lg:py-28">
                <div className="mx-auto grid max-w-7xl grid-cols-1 gap-14 px-6 lg:grid-cols-12 lg:px-12">
                    <div className="lg:col-span-7">
                        {intro.map((p, i) => (
                            <Reveal key={i} delay={i * 0.08}>
                                <p className={`${i === 0 ? "text-lg text-navy" : "mt-5 text-base text-slate-600"} leading-relaxed`}>
                                    {p}
                                </p>
                            </Reveal>
                        ))}
                        <Reveal delay={0.15}>
                            <h2 className="mt-12 font-display text-2xl font-bold tracking-tight text-navy sm:text-3xl">
                                {coveredTitle}
                            </h2>
                        </Reveal>
                        <div className="mt-8 grid grid-cols-1 gap-px border border-slate-200 bg-slate-200 sm:grid-cols-2">
                            {covered.map((item, i) => (
                                <Reveal key={item} delay={Math.min(i * 0.05, 0.3)} className="bg-white">
                                    <div className="flex h-full items-start gap-3 p-5">
                                        <CheckCircle2 size={17} className="mt-0.5 shrink-0 text-amber" />
                                        <span className="text-sm leading-relaxed text-slate-700">{item}</span>
                                    </div>
                                </Reveal>
                            ))}
                        </div>
                        {closing && (
                            <Reveal delay={0.1}>
                                <p className="mt-10 border-l-2 border-amber pl-5 text-base leading-relaxed text-slate-600">
                                    {closing}
                                </p>
                            </Reveal>
                        )}
                        <Reveal delay={0.15}>
                            <Link
                                to={ctaLink}
                                className="mt-10 inline-flex items-center gap-2 bg-navy px-7 py-3.5 font-mono text-xs font-semibold uppercase tracking-[0.18em] text-white transition-colors duration-300 hover:bg-amber"
                                data-testid="service-page-cta"
                            >
                                {ctaLabel} <ArrowRight size={14} />
                            </Link>
                        </Reveal>
                    </div>
                    <div className="lg:col-span-5">
                        <Reveal delay={0.1}>
                            <div className="tick-frame sticky top-28">
                                <img src={image} alt={imageAlt} className="aspect-[4/5] w-full object-cover" loading="lazy" />
                            </div>
                        </Reveal>
                    </div>
                </div>
            </section>

            {gallery}

            <CtaSection />
        </div>
    );
}
